/** eBay-Sites für Filter und Anzeige aus core; DACH und UK zuerst, Bezeichnung = Domain. */
import { EBAY_SITES as CORE_SITES, ebaySite } from '@pat/core/sites';

const PREFERRED = [77, 16, 193, 3];

function label(id: number, domain: string): string {
  return id === 100 ? 'eBay Motors' : domain;
}

export const EBAY_SITES: ReadonlyArray<{ id: number; label: string }> = [
  ...PREFERRED.map(id => CORE_SITES.find(site => site.id === id)).filter(site => site !== undefined),
  ...CORE_SITES.filter(site => !PREFERRED.includes(site.id)),
].map(site => ({ id: site.id, label: label(site.id, site.domain) }));

export function siteLabel(id: number): string {
  const site = ebaySite(id);
  return site ? label(site.id, site.domain) : `Site ${id}`;
}
